import classnames from 'classnames';
import { profitTypes } from 'live/components/index.shared';
import TopList from 'live/components/TopList';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import ChevronDown from 'shared/components/icon/ChevronDown';
import Dropdown from 'shared/components/input/Dropdown';
import { getText } from 'shared/utils/Text';
import { getUrl } from 'shared/utils/urls';

import styles from './index.module.scss';

const TopProfit = ({
  data,
  full = false,
  month,
  section,
  type,
  year,

  loadDididends,
  loadProfits,
  onChange,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const sort = ['dividend', 'asc'].join(',');
  const size = full ? 30 : 10;
  const { error, list, loading } = data[type];

  useEffect(() => {
    type === profitTypes[0]
      ? loadDididends({ month, size, sort, year })
      : loadProfits({ month, size, sort, year });
  }, [loadDididends, loadProfits, month, size, sort, type, year]);

  const showAll = section === 'leaders' && full;
  const monthName = getText(`month-full-${month}`);
  const toggleCollapsed = () => setCollapsed(!collapsed);
  const handleChange = e => {
    setCollapsed(false);
    onChange(e);
  };

  return (
    <div
      className={classnames(styles.container, {
        [styles.collapsed]: collapsed,
        [styles.showAll]: showAll,
      })}
    >
      {!showAll && (
        <div className={styles.header} onClick={toggleCollapsed}>
          {getText('page-live-toplist-header')}&nbsp;
          {monthName} {year}
          <ChevronDown className={styles.arrow} />
        </div>
      )}
      <Dropdown
        caption={
          full
            ? `${getText(
                `page-live-history-top-${type}`,
              )} - ${monthName} ${year}`
            : getText(`page-live-history-top-${type}`)
        }
        onChange={handleChange}
        className={styles.dropdown}
        value={type}
        values={profitTypes.map(value => ({
          disabled: value === type,
          text: getText(`page-live-history-top-${value}`),
          value,
        }))}
      />

      {list && (
        <>
          <div className={styles.list}>
            <TopList
              error={error}
              full={full}
              limit={3}
              list={list}
              loading={loading}
              showPosition
              type={type}
            />
          </div>
          {showAll && (
            <div className={styles.listSecondary}>
              <TopList
                full
                offset={3}
                type={type}
                list={list}
                loading={loading}
                error={error}
              />
            </div>
          )}
        </>
      )}

      {!showAll && (
        <>
          <div className={styles.explain}>
            {getText('page-live-toplist-explain')}
          </div>

          <Link className={styles.buttonFullList} to={getUrl.live('leaders')}>
            {getText('page-live-toplist-button-full-list')}
          </Link>
        </>
      )}
    </div>
  );
};

TopProfit.propTypes = {
  data: PropTypes.shape({
    dividends: PropTypes.shape({
      error: PropTypes.string,
      list: PropTypes.array,
      loading: PropTypes.bool,
    }),
    profits: PropTypes.shape({
      error: PropTypes.string,
      list: PropTypes.array,
      loading: PropTypes.bool,
    }),
  }),
  full: PropTypes.bool,
  section: PropTypes.string,
  month: PropTypes.number,
  type: PropTypes.string,
  year: PropTypes.number,

  loadDididends: PropTypes.func,
  loadProfits: PropTypes.func,
  onChange: PropTypes.func,
};

export default TopProfit;
